import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import ViewObservationFormTableCellButton from "../ViewObservationFormTableCellButton/ViewObservationFormTableCellButton";

export interface GreatConversationTableCellProps {
	cellValue?: TableCellValue;
	userId?: number;
	storeId?: number;
}

const GreatConversationTableCell: FC<GreatConversationTableCellProps> = ({
	cellValue,
	userId,
	storeId
}) => {
	const { control, setValue } = useFormContext<ReportDetailForm>();

	const { showGradingReport } = useWatch({
		control,
		name: "filters"
	});

	const handleObservationSuccessButtonClick = () => {
		if (!cellValue || !cellValue.month) return;

		setValue("filters.userId", userId);
		setValue("filters.month", cellValue.month);
	};

	if (!cellValue || cellValue.month === null) {
		return <span>-</span>;
	}

	const { complete, graded } = cellValue;

	if (!showGradingReport) {
		if (userId) {
			return (
				<ViewObservationFormTableCellButton
					onClick={userId ? handleObservationSuccessButtonClick : undefined}
					totalNumObservations={complete}
				>
					{complete}
				</ViewObservationFormTableCellButton>
			);
		}

		return <span>{complete}</span>;
	}

	// calculate the percentage and floor it, because 99% is still not 100% compliant.
	const total = Math.floor((graded / complete) * 100);

	if (isNaN(total)) {
		return <span>-</span>;
	}

	if (total === 100 && storeId) {
		return (
			<ViewObservationFormTableCellButton
				onClick={userId ? handleObservationSuccessButtonClick : undefined}
				totalNumObservations={complete}
				showIcon={true}
				graded={true}
				observationType="GREAT_CONVERSATION"
			/>
		);
	}

	if (total === 0 && storeId) {
		return (
			<ViewObservationFormTableCellButton
				onClick={userId ? handleObservationSuccessButtonClick : undefined}
				totalNumObservations={complete}
				showIcon={true}
				graded={false}
				observationType="GREAT_CONVERSATION"
			/>
		);
	}

	return <span>{`${total}%`}</span>;
};

export default GreatConversationTableCell;
